export var INVALID_AMOUNT_MESSAGE = 'Amount is invalid.';
export var INVALID_SCALE_MESSAGE = 'Scale is invalid.';
export var INVALID_RATIOS_MESSAGE = 'Ratios are invalid.';
export var UNEQUAL_SCALES_MESSAGE = 'Objects must have the same scale.';
export var UNEQUAL_CURRENCIES_MESSAGE = 'Objects must have the same currency.';